import styled from 'styled-components';

const Title = styled.span`
    font-weight: normal;
    font-size: 1.5em;
`;

export { Title };
